import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast, Toaster } from "sonner";
import { Trash2, Mail } from "lucide-react";

export default function AdminContacts() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        setLoading(true);
        try {
            const r = await api.get("/admin/contacts");
            setItems(r.data);
        } catch {
            toast.error("Errore caricamento");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, []);

    const remove = async (id) => {
        if (!window.confirm("Eliminare questo messaggio?")) return;
        try {
            await api.delete(`/admin/contacts/${id}`);
            load();
        } catch {
            toast.error("Errore");
        }
    };

    return (
        <div data-testid="admin-contacts-page">
            <Toaster position="top-center" richColors />
            <div className="kicker mb-3">CMS · Messaggi</div>
            <h1 className="font-display text-4xl md:text-5xl font-extrabold tracking-[-0.03em] mb-10">
                Messaggi ricevuti
            </h1>

            {loading ? (
                <div className="text-white/50">Caricamento…</div>
            ) : items.length === 0 ? (
                <div className="border border-white/10 p-12 text-center text-white/60" data-testid="contacts-empty">
                    Nessun messaggio ricevuto.
                </div>
            ) : (
                <div className="space-y-4">
                    {items.map((c) => (
                        <div key={c.id} className="border border-white/10 p-6" data-testid={`contact-${c.id}`}>
                            <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                                <div>
                                    <div className="kicker mb-1">{c.kind || "general"}</div>
                                    <div className="font-display text-xl font-bold">{c.name}</div>
                                    <a href={`mailto:${c.email}`} className="text-white/70 link-underline inline-flex items-center gap-2">
                                        <Mail size={14} /> {c.email}
                                    </a>
                                </div>
                                <div className="text-xs text-white/40">
                                    {new Date(c.created_at).toLocaleString("it-IT")}
                                </div>
                            </div>
                            {c.subject && <div className="kicker text-white/50 mb-2">Oggetto: {c.subject}</div>}
                            <p className="text-white/80 whitespace-pre-line">{c.message}</p>
                            <div className="mt-5 flex justify-end">
                                <button
                                    onClick={() => remove(c.id)}
                                    className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-red-400"
                                    data-testid={`delete-contact-${c.id}`}
                                >
                                    <Trash2 size={14} /> Elimina
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
